"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the dotScale for progressDots to style them accordingly
 * Depending on the available space, different numbers of dots are displayed.
 * To make it clear that there are more dots, the dots on the edge are styled smaller
 * @param index Current dot that should get a style
 * @param dotsCount Number of available dots
 * @param dotsCountVisible Max number of visible dots
 * @param dotActive Index of dot that's currently selected
 */
exports.default = (function (index, dotsCount, dotsCountVisible, dotActive) {
    // dotsCountMax has to be uneven
    var maxItemsCountUsed = dotsCountVisible % 2 ? dotsCountVisible : dotsCountVisible - 1;
    var inRange = function (diff) { return Math.abs(index - dotActive) <= maxItemsCountUsed / 2 - diff; };
    var atStart = function (diff) { return dotActive < index && index <= maxItemsCountUsed - 1 - diff; };
    var atEnd = function (diff) { return dotActive > index && index >= dotsCount - (maxItemsCountUsed - diff); };
    var isActive = dotActive === index;
    // Don't change scale of dots if they're the first or last dots
    // const first = dotActive > index && dotActive <= (maxItemsCountUsed - 1) / 2;
    // const last = dotActive < index && dotActive >= dotsCount - 1 - (maxItemsCountUsed - 1) / 2;
    var dotScale = 0;
    if (inRange(0) || atStart(0) || atEnd(0))
        dotScale = 0.45;
    if (inRange(1) || atStart(1) || atEnd(1))
        dotScale = 0.73;
    if (inRange(2) || atStart(2) || atEnd(2) || isActive)
        dotScale = 1;
    return dotScale;
});
//# sourceMappingURL=getDotScale.js.map